import { Select } from '@mantine/core';
import { GridApi } from 'ag-grid-community';
import useFilterValue, { FilterChangeCallback } from 'components/tables/filters/hooks/use-filter-value';

/**
 * Localized boolean options used by translated table columns.
 */
export const YES_NO_OPTIONS = [
  { value: 'Áno', label: 'Áno' },
  { value: 'Nie', label: 'Nie' },
];

/**
 * Parameters supplied by the table to a configured yes/no filter.
 */
export interface YesNoSelectFilterProps {
  api: GridApi;
  onChange?: FilterChangeCallback;
}

interface ConfigureYesNoSelectFilterProps {
  filterKey: string;
}

type FullYesNoSelectFilterProps = YesNoSelectFilterProps & ConfigureYesNoSelectFilterProps;

/**
 * Floating select filter for columns containing localized Áno/Nie values.
 */
export default function YesNoSelectFilter({ api, filterKey, onChange }: FullYesNoSelectFilterProps) {
  const [value, setValue] = useFilterValue({ api, filterKey, onChange });

  return (
    <Select clearable w="100%" size="sm" placeholder="Všetky" data={YES_NO_OPTIONS} value={value} onChange={setValue} />
  );
}

YesNoSelectFilter.configure = (config: ConfigureYesNoSelectFilterProps) => (props: YesNoSelectFilterProps) =>
  <YesNoSelectFilter {...config} {...props} />;
